class DomainOptionsApi {
  static async getPlans(userToken) {
    const response = await fetch('/api/v1/domain_options', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'User-Token': userToken,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin'
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'プラン情報の取得に失敗しました')
    }

    return await response.json()
  }

  static async addPlan(userToken, planId) {
    const response = await fetch('/api/v1/domain_options', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'User-Token': userToken,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        domain_option_plan_id: planId
      })
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'プランの追加に失敗しました')
    }

    return await response.json()
  }

  static async changePlan(userToken, planId) {
    const response = await fetch('/api/v1/domain_options', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'User-Token': userToken,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        domain_option_plan_id: planId
      })
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'プランの変更に失敗しました')
    }

    return await response.json()
  }

  static async cancelPlan(userToken) {
    const response = await fetch('/api/v1/domain_options', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'User-Token': userToken,
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      credentials: 'same-origin'
    })

    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.error || 'プランの解約に失敗しました')
    }

    return await response.json()
  }
}

export default DomainOptionsApi
